<template>
    <div class="page-equipment">
        <banner-carousel></banner-carousel>
        <div class="container">
            <!-- 化妆品入口 -->
            <router-link to="/cosmetics"
                class="equipment-to_cosmetics">
                化妆品专区入口
                <i class="el-icon-d-arrow-right"></i>
            </router-link>
            <!-- 搜索框 -->
            <main-filter>
            </main-filter>
            <!-- 热门 -->
            <main-hot
                hot-title="热销产品"
                list-router="/equipment/list">
                <template #goodsItem>
                    <goods-item
                        router-path="/equipment/detail">
                    </goods-item>
                </template>
            </main-hot>
        </div>
    </div>
</template>

<script>
    export default {
        components: {
            bannerCarousel: () => import('@/components/bannerCarousel'),
            mainFilter: () => import("@/components/equipment/mainFilter"),
            mainHot: () => import("@/components/imageMall/mainHot"),
            goodsItem: () => import("@/components/imageMall/goodsItem")
        },
    }
</script>

<style scoped>
.page-equipment{
    --color: #8d9afc;
    background-color: #fff;
    margin-bottom: 50px;
}
.equipment-to_cosmetics{
    display: block;
    text-align: center;
    margin: 50px auto;
}
.equipment-to_cosmetics,
.equipment-to_cosmetics > i{
    font-size: 24px;
    color: #303133;
}
</style>